import Vue from 'vue';
import Vuex, { mapState } from 'vuex';
import core from '@groovepages/gd-lib/core-store';
import records from '@groovepages/gd-lib/records-store';
import domains from '@groovepages/gd-lib/domain-store';
import subdomains from '@groovepages/gd-lib/subdomains-store';
import mailing from '@/store/modules/mailing';
import forms from '@/store/modules/forms';
import loader from "@/store/modules/loader";
import demoMode from './store/modules/demoMode';
import filters from './store/modules/filters';

Vue.use(Vuex);

Vue.mixin({
  computed: {
    ...mapState(['lang'])
  }
});

export default new Vuex.Store({
  ...core,
  modules: {
    demoMode,
    mailing,
    forms,
    loader,
    records,
    domains,
    subdomains,
    filters
  },
  getters: {
    ...core.getters,
    supBrand: state => {
      if (state.brandData && state.brandData.apps) {
        return state.brandData.apps.find(app => app.slug === 'mail');
      }
      return null;
    },
    subBrandUrl: state => state.brandData.apps.find(app => app.slug === 'mail').url, // input: /groovemail/
    appName: state => state.brandData.brandName, // input: groove
    appUrl: state => state.brandData.brandUrl, // input: "https://grooveFunnels.com"
    brandAltName: state => state.brandData.brandAltName, // input: GrooveFunnels
    user: state => state.user,
    /**
     * Check if current user is allowed for testing new features.
     */
    canUseNewFeature: (state) => {
      const allowedUsers = [
        '5f0d5d4a6ca1bd0016c5142f', // Pankaj's account
      ];
      return state && state.user && state.user.id ? allowedUsers.includes(state.user.id) : false;
    },
    pluginSiteSettings: (state, getters) => {
      return {
        integrations:
          (state.user &&
            state.user.metadata &&
            state.user.metadata.integrations) ||
          []
      };
    }
  }
});
